<template>
  <div style="overflow: hidden">
    <div class="row">
      <div
        v-if="
          !isObjEmpty(batch) &&
            ((batch.additional_cannabinoids && batch.additional_cannabinoids.length > 0) || product.predominate_canabinoid) &&
            showBatchAdditionalCannabinoids
        "
        class="col-12"
      >
        <CannabinoidsList
          :cannabinoids="batch.additional_cannabinoids"
          :show-predominate-canabinoid="showBatchPredominateCanabinoidDetails"
          :predominate-canabinoid-type="product.predominate_canabinoid"
          :predominate-canabinoid-min="batch.predominate_canabinoid_min_or_only"
          :predominate-canabinoid-max="batch.predominate_canabinoid_max"
          :predominate-canabinoid-unit="batch.predominate_canabinoid_unit"
        />
      </div>
      <div class="col-12">
        <TerpenesList
          v-if="batch.terpenes && batch.terpenes.length > 0 && showBatchTerpenes"
          :terpenes="batch.terpenes"
        />
        <div
          v-if="batch.terpenes && batch.terpenes.length > 0 && showBatchTerpenes && showTHCLimit && batch.thc_limit"
          class="mb-4"
        >
          <hr>
        </div>
        <div
          v-if="showTHCLimit && batch.thc_limit"
          class="row mb-2"
        >
          <div class="col-12">
            <div class="d-table h-100 w-100">
              <h5 class="text-light font-weight-normal mb-2 text-left text-capitalize d-table-cell align-middle text-nowrap">
                THC Compliant
              </h5>
            </div>
          </div>
          <div class="col-12">
            <div class="d-table h-100 w-100 text-right mt--half">
              <i
                v-if="batch.thc_limit"
                id="thc_compliant"
                class="bushel-icon bushel-3x mt-2 bushel-thc"
              />
              <BTooltip
                target="thc_compliant"
                triggers="hover"
              >
                THC Compliant
              </BTooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  showBatchPredominateCanabinoidDetailsCheck,
  showBatchTerpenesCheck,
  showBatchAdditionalCannabinoidsCheck,
  showTHCLimitCheck,
} from "@/services/inventory/showBatchFieldChecks";
import CannabinoidsList from "./CannabinoidsList.vue";
import TerpenesList from "./TerpenesList.vue";
import { isObjEmpty } from "@/services/helpers";

export default {
  components: {
    CannabinoidsList,
    TerpenesList,
  },
  props: {
    product: { type: Object, required: true },
    batch: { type: Object, required: true },
  },
  data() {
    return {
      industry: APP_INDUSTRY,  
    };
  },
  computed: {
    showBatchPredominateCanabinoidDetails() {
      return showBatchPredominateCanabinoidDetailsCheck(this.product.category.name);
    },
    showBatchTerpenes() {
      return showBatchTerpenesCheck(this.product.category.name);
    },
    showBatchAdditionalCannabinoids() {
      return showBatchAdditionalCannabinoidsCheck(this.product.category.name);
    },
    showTHCLimit() {
      return showTHCLimitCheck(this.product.category.name, this.industry);
    },
  },
  methods: {
    isObjEmpty,
  },
};
</script>
